import { createFileRoute, Link } from "@tanstack/react-router";
import {
  agentsBreadcrumbJsonLd,
  agentsJsonLd,
  agentsRouteHead,
} from "@/lib/agents-seo";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import { AGENTS_PAGE } from "@/content/marketing";
import { AgentAuthor } from "@/components/landing/AgentAuthor";
import { AgentConnect } from "@/components/landing/AgentConnect";
import { AgentsHero } from "@/components/landing/AgentsHero";
import { FinalCta } from "@/components/landing/FinalCta";
import "@/styles/marketing-pages.css";

export const Route = createFileRoute("/_home/agents")({
  ssr: true, // public SEO route (D-216-5)
  head: agentsRouteHead,
  component: AgentsPage,
});

function AgentsPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(agentsJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: jsonLdScript(agentsBreadcrumbJsonLd),
        }}
      />
      <nav aria-label="Breadcrumb" className="sr-only">
        <ol>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-current="page">AI tools</li>
        </ol>
      </nav>
      {/* Top-level landmark so assistive tech can skip the nav (#416); the
          layout's SiteFooter is a sibling, so contentinfo survives. */}
      <main className="gs-marketing-page">
        <AgentsHero />
        <AgentAuthor />
        <AgentConnect />
        <FinalCta content={AGENTS_PAGE.finalCta} />
      </main>
    </>
  );
}
